import React, { useEffect, useState } from "react";
import { CTA } from "@2po-dpam/components";
import { Spinner } from "reactstrap";
import { useContextStore, useLink, useContentfulFormalizr } from "@hooks";
import { CTAVariations, ICta } from "@types";
import { getFixedUrlIfMarketAndLanguageDoesNotExist } from "@utils/url";

type Props = {
    options?: {
        type?: string;
        inline?: boolean;
        color?: string;
        className?: string;
        noUnderline?: boolean;
        variant?: CTAVariations;
        theme?: string;
    };
    setSubmitRedirect?: (redirect: string) => void;
    data?: Omit<ICta, "text"> & {
        ctaText: string;
    };
};

const FormalizerButton = ({ setSubmitRedirect, data }: Props) => {
    const { language, market } = useContextStore();
    const { isSubmitting } = useContentfulFormalizr();
    const [hrefToUse, setHrefToUse] = useState<string | undefined>(undefined);
    const { internalLink, externalLink } = useLink(data);

    useEffect(() => {
        const link = internalLink || externalLink;

        if (link && language)
            setHrefToUse(
                getFixedUrlIfMarketAndLanguageDoesNotExist(
                    link,
                    language,
                    market,
                ),
            );
    }, []);

    if (setSubmitRedirect && hrefToUse) {
        setSubmitRedirect(hrefToUse);
    }

    return (
        <CTA
            disabled={isSubmitting}
            fullWidth
            onClick={() => null}
            type="submit"
        >
            {!isSubmitting ? data?.ctaText : <Spinner />}
        </CTA>
    );
};

export default FormalizerButton;
